import { history } from '../../wlHistory';
import { UrlHelper } from '../../hoc/UrlHelper';
import { rateAppManager } from '../../singletons';
import { TriggeringEvent } from '../../types/RateApp';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import { Translator } from 'Translator';

function getLastIndexOfSlashToCut(pathname) {
  return pathname.split('?')[0].slice(-1) === '/' ? pathname.split('?')[0].slice(0, -1).lastIndexOf('/') : pathname.lastIndexOf('/');
}

function getUpdatedRoute(tab) {
  let pathname;
  let index;
  if (!history.location) {
    pathname = window.location.href;
    // We don't want the file:///android in our history
    if (PLATFORM === 'cordova') {
      pathname = pathname.substr(pathname.indexOf('/'), pathname.length - 1);
    }
    index = getLastIndexOfSlashToCut(pathname);
    const queryStart = pathname.lastIndexOf('?');
    if (queryStart > 0) {
      return pathname.slice(0, index) + tab + pathname.substr(queryStart);
    } else {
      const slicedPath = pathname.slice(0, index);
      return slicedPath.endsWith('messages') ? pathname + tab : slicedPath + tab;
    }
  }
  const search = history.location.search;
  pathname = history.location.pathname;
  index = getLastIndexOfSlashToCut(pathname);
  return pathname.slice(0, index) + tab + search;
}

const methods = {
  goTo: function(url, openInNewTab = false) {
    console.log('goTo: ', url);
    if (openInNewTab) {
      return window.open(url, '_blank');
    } else {
      if (PLATFORM === 'cordova' && url.includes('/invite/')) {
        if (url.includes('http')) {
          window.open(url, '_system');
        } else {
          const fixedPath = url.startsWith('/') ? url : `/${url}`;
          window.open(`${URL_API_HOST}${fixedPath}`, '_system');
        }
        return;
      }
      if (url.indexOf('http') > -1) {
        const { pathname } = new URL(url);
        return history.push(pathname);
      } else {
        return history.push(url);
      }
    }
  },
  goBack: function() {
    if (window.location.href.indexOf('/messages/') >= 0) {
      history.push('/messages/');
      return;
    }
    if (window.location.href.indexOf('/action/') >= 0) {
      history.push('/action/');
      return;
    }
    if (window.location.href.indexOf('/schedule/') >= 0) {
      history.push('/schedule/');
      return;
    }
  },
  howItWorks: function() {
    methods.goTo(UrlHelper.url('/info/how-it-works/'), true);
  },
  myOffers: function() {
    methods.goTo(UrlHelper.url('/dashboard/listings/'));
  },
  hostAgenda: function() {
    history.push(generatePathnameWithLangCode('/host-agenda/', Translator.getLanguageCode()));
  },
  toReviewPage: function(id) {
    rateAppManager.trigger(TriggeringEvent.REVIEW_GIVEN);
    history.push(generatePathnameWithLangCode(`/manage/review/${id}/`, Translator.getLanguageCode()));
  },
  withlocals: function() {
    methods.goTo(UrlHelper.getBaseUrl());
  },
  myAssignments: function() {
    methods.goTo(UrlHelper.url('/dashboard/hosts/'));
  },
  help: function() {
    methods.goTo('https://support.withlocals.com', true);
  },
  voucher: function(tripId, guestId) {
    const url = UrlHelper.url('/pdfs/vouchers/' + tripId + '/' + guestId + '/', false);
    if (window.cordova) {
      document.addEventListener('deviceready', function() {
        console.log('url: ', url);
        window.open(url, '_system');
      }, false);
    } else {
      window.open(url, '_blank');
    }
  },
  toContact: function() {
    const url = UrlHelper.url('/info/contact/');
    methods.goTo(url);
  },
  toDetails: function() {
    methods.switchTab(getUpdatedRoute('/details/'));
  },
  toChat: function() {
    methods.switchTab(getUpdatedRoute('/chat/'));
  },
  toOffers: function() {
    methods.switchTab(getUpdatedRoute('/offers/'));
  },
  toExperience: function(id) {
    history.push(`/experience/${id}/`);
  },
  findThingsToDoIn: function(country, city) {
    let url = `/s/`;
    if (!!country) {
      url += `${country.replace(/ /g, '-').toLowerCase()}/`;
      if (!!city) {
        url += `${city.replace(/ /g, '-').toLowerCase()}/`;
      }
    }

    methods.goTo(url);
  },
  findThingsToDoFromBooking(booking) {
    let country;
    let city;

    if (!!booking) {
      country = booking.getIn(['location', 'components', 'country']).toLowerCase();
      city = booking.getIn(['location', 'components', 'locality']).toLowerCase();
    }
    country = methods.replaceSpaces(country);
    country = methods.theNetherlandsFix(country);
    methods.findThingsToDoIn(country, city);
  },
  replaceSpaces(value) {
    return value.replace(' ', '-');
  },
  theNetherlandsFix(country) {
    if (country !== 'the-netherlands') {
      country = country.replace('netherlands', 'the-netherlands');
    }
    return country;
  },
  toSelectedSchedule(bookingId, search) {
    const url = `/schedule/${bookingId}/details/`;
    history.push({ pathname: url, search: search });
  },
  toSelectedMessage(contactId) {
    const url = `/messages/${contactId}/chat/`;
    history.push(url, {}, {
      url: url,
      contactId: contactId,
    });
  },
  toSelectedAction(bookingId) {
    const url = `/action/${bookingId}/chat/`;
    methods.goTo(url);
  },
  switchTab(url) {
    methods.goTo(url);
  },
  toNewOffer(flow) {
    const userRequestId = flow?.threadSummary?.lastUserRequest?.id ?? flow?.aggregate?.lastUserRequset?.id;
    if (userRequestId) {
      methods.goTo(`/create-personalized-offer/${userRequestId}/request/`);
    } else {
      methods.goTo(`/new-personalized-offer/${get(flow, 'contact.id')}/request/`);
    }
  }
};

export default {
  menu: methods,
};
